// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__3WK3C","rootCenter":"LoadMoreObserver_rootCenter__1QDls","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__3MaJQ"};